<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <div *ngIf="!isSiteIntl" edsSpacing="md">
      <div edsSubGrid="layout-1" edsSubGridGap="lg">
        <ft-distribution-schedules
          [schedules]="schedules"
        ></ft-distribution-schedules>
        <ft-rates-and-yields
          *ngIf="showRatesAndYieldsSection"
          [salesChargeBreakPoints]="salesChargeBreakPoints"
          [yields]="yields"
          [productType]="productType"
          [fundId]="brConfig.fundId"
          [navDate]="latestConfig?.navDate"
        ></ft-rates-and-yields>
      </div>
    </div>
    <ng-container *ngIf="!hideDistributionPerShare">
      <div edsRow>
        <div edsCol>
          <eds-proximal placement="DividendsProximalTop"></eds-proximal>
          <eds-section-header
            [title]="heading"
            [level]="3"
            [size]="'h3'"
            [asOfLabel]="'products.as-of' | translate"
            caveatPlacement="Distribution:DividendsPriceDistribution"
            edsSpacing="md"
          ></eds-section-header>
        </div>
      </div>

      <div
        edsSpacing="sm"
        edsFlexbox
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
      >
        <div edsGrid>
          <div edsSubGrid="layout-7" edsSubGridTablet="layout-7">
            <eds-dropdown
              [edsSpacing]="(isHandheld$ | async) === true ? 'sm' : ''"
              ariaLabel="Dropdown"
              [dropdownId]="id"
              name="distribution-year-select"
              label="{{ 'products.year' | translate }}"
              [items]="yearOptionList"
              [titleText]="getTitleText(yearOptionSelected)"
              [selectedText]="yearOptionSelected"
              (dropdownChange)="updateDistributionHistoryTable($event)"
            ></eds-dropdown>

            <div
              edsFlexbox
              alignItems="center"
              justifyContent="flex-end"
              class="dp-input-container"
            >
              <eds-toggle
                [toggleButtons]="toggleButtons"
                (toggleActive)="onToggleActive($event)"
              ></eds-toggle>
            </div>
          </div>
        </div>
      </div>
      <div [hidden]="selectedTab === 'table'" edsSpacing="sm">
        <ft-distribution-chart-view
          [highChartOptions]="highChartOptions"
        ></ft-distribution-chart-view>
      </div>

      <div *ngIf="selectedTab === 'table'" edsSpacing="sm">
        <ft-distribution-table-view
          [productType]="productType"
          [tableConfig]="tableConfig"
          [latestConfig]="latestConfig"
          [filteredHistoricalList]="filteredHistoricalList"
          [historicalTableTotalPages]="historicalTableTotalPages"
          [fundId]="brConfig.fundId"
          [isSiteIntl]="isSiteIntl"
          [configurationName]="componentConfiguration?.configurationName"
          (selectedPage)="onPageChanged($event)"
          (downloadAction)="onDownloadButtonClicked()"
        ></ft-distribution-table-view>
      </div>
      <div edsSpacing="md">
        <button edsButton="secondary" (click)="onDownloadButtonClicked()">
          <eds-icon
            type="download"
            size="small"
            edsPadding
            edsPaddingRight="xs"
          ></eds-icon>
          {{
            "products.distribution-download-historical-distributions"
              | translate
          }}
          ({{ "products.xls-file-extension" | translate }})
        </button>
      </div>
      <eds-proximal placement="DividendsProximalBottom"></eds-proximal>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5>Distribution Chart</h5>
</ng-template>
